<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.system">
          <form-group
            horizontal
            name="status"
            :label="$t('attributes.activation_status')"
          >
            <b-switch
              v-model="system.status"
              name="status"
              true-value="1"
              false-value="0"
            ></b-switch>
          </form-group>

          <form-group
            horizontal
            name="is_menu"
            :label="$t('attributes.is_menu')"
          >
            <b-switch
              v-model="system.is_menu"
              name="is_menu"
              true-value="true"
              false-value="false"
            ></b-switch>
          </form-group>

          <form-group horizontal name="title" :label="$t('attributes.title')">
            <b-input
              v-model="system.title"
              @input="$v.system.title.$touch()"
              name="title"
              :placeholder="$t('message.please_input') + $t('attributes.title')"
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="name"
            :label="$t('attributes.system_name')"
          >
            <b-input
              v-model="system.name"
              @input="$v.system.name.$touch()"
              name="name"
              :placeholder="
                $t('message.please_input') + $t('attributes.system_name')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group horizontal name="sort" :label="$t('attributes.sort')">
            <b-numberinput
              v-model.number="system.sort"
              @input="$v.system.sort.$touch()"
              name="sort"
              min="0"
              max="99"
              :placeholder="$t('message.please_input') + $t('attributes.sort')"
            >
            </b-numberinput>
          </form-group>

          <form-group
            addons
            horizontal
            name="icon"
            :label="$t('attributes.icon')"
          >
            <b-input
              v-model="system.icon"
              @input="$v.system.icon.$touch()"
              name="icon"
              :placeholder="$t('message.please_input') + $t('attributes.icon')"
              :icon="system.icon"
              expanded
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="isLoading" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button :loading="isLoading" type="is-primary" native-type="submit">
          {{ submitTitle }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { required, numeric, maxLength, between } from 'vuelidate/lib/validators'

export default {
  name: 'MainSystemForm',

  props: {
    isLoading: Boolean,
    id: {
      type: Number,
      default: null
    },
    status: {
      type: String,
      default: '1'
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    sort: {
      type: Number,
      default: 99
    },
    is_menu: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    const isEditing = this.id !== null
    const formTitle =
      this.$t(isEditing ? 'attributes.modify' : 'attributes.add') +
      this.$t('attributes.main_system')
    const submitTitle = this.$t(
      isEditing ? 'attributes.update' : 'attributes.add'
    )

    return {
      isEditing,
      formTitle,
      submitTitle,
      system: {
        id: this.id,
        status: this.status,
        title: this.title,
        name: this.name,
        sort: this.sort,
        is_menu: this.is_menu,
        icon: this.icon
      }
    }
  },
  validations: {
    system: {
      status: {},
      title: { required, maxLength: maxLength(50) },
      name: { maxLength: maxLength(50) },
      sort: { required, numeric, between: between(0, 99) },
      is_menu: { required },
      icon: { maxLength: maxLength(50) }
    }
  },
  methods: {
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.system)
    }
  }
}
</script>
